var exports = {
  "a": "Box__ewpfXX",
  "r": "wrapping__nU9R5R",
};

module.exports = exports;
